import React from 'react'
import PropTypes from 'prop-types'
import { Link } from 'react-router-dom'
import ArrowForwardIcon from '@mui/icons-material/ArrowForward'
import { Button } from '../../../features/section-components/Button'
import styles from '../MyAccount.module.scss'

function LinkAccountItemContainer({
  t, link, onClick, mobile, renderData, formatPhoneToNational, phoneNumber
}) {
  if (mobile) {
    return (
      <div className={styles['mobile-account-item-container']} data-testid="renderData">
        {renderData(
          t('label-phone-num'),
          formatPhoneToNational(phoneNumber)
        )}
        <Link
          to={link}
          style={{ display: 'inline-block', width: '100%' }}
          onClick={onClick}
        >
          <Button
            text={t('button-edit')}
            buttonStyle="cta-grey-oval-edit-profile-info-mobile"
            endIcon={<ArrowForwardIcon />}
            iconSize="small"
          />
        </Link>
      </div>
    )
  }
  return (
    <div className={styles['account-item-container']} data-testid="renderData">
      {renderData(
        t('label-phone-num'),
        formatPhoneToNational(phoneNumber)
      )}
      <Link
        to={link}
        style={{ display: 'inline-block' }}
        onClick={onClick}
      >
        <Button
          text={t('button-edit')}
          buttonStyle="cta-grey-oval-edit-profile-info"
          endIcon={<ArrowForwardIcon />}
          iconSize="small"
        />
      </Link>
    </div>
  )
}

LinkAccountItemContainer.propTypes = {
  t: PropTypes.func.isRequired,
  link: PropTypes.string.isRequired,
  onClick: PropTypes.func.isRequired,
  renderData: PropTypes.func.isRequired,
  phoneNumber: PropTypes.string.isRequired,
  formatPhoneToNational: PropTypes.func.isRequired,
  mobile: PropTypes.bool
}

LinkAccountItemContainer.defaultProps = {
  mobile: false
}

export default LinkAccountItemContainer
